import html2pdf from "html2pdf.js";
import React, { useState } from "react";
import ReactHlsPlayer from "react-hls-player";
import { BsFolderSymlink, BsPerson } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { Timer } from "../../../Services";
import S from "../../../Services/GeneralServices";
import { feedbackUrl } from "../../../api/basr_url";
import intApi from "../../../api/int_api";
import { FeedbackSkill } from "../../../component/FeedbackComponent/FeedbackSkill";
import ScoringDefinition from "../../../component/FeedbackComponent/ScoringDefinition";
import ImageView from "../../../component/ImageView";
import { encryptUrl } from "../../../utils/encryption";

const ViewTechFeedbackNamIT: React.FC = () => {
  const [scheduleDetail, setSchedule] = React.useState({} as any);
  const { schedule_id } = useParams();
  const [openImageFullView, setOpenImageFullView] = React.useState(false);
  const [base64Img, setBase64Img] = React.useState<string | null>(null);

  React.useEffect(() => {
    setTimeout(() => {}, 1000);
  }, []);

  React.useEffect(() => {
    getFeedback();
  }, []);

  const getFeedback = async () => {
    const res = await intApi.getFeedback(schedule_id);
    await getProfileURL(res.data.schedule["feedback"][0]["url"]);
    setSchedule(res.data.schedule);
  };

  const downloadPDF = async () => {
    var viewchat = document.getElementById("viewchat");
    if (viewchat) {
      viewchat.style.display = "none";
    }
    const element = document.getElementById("pdfdocument");
    const options = {
      margin: 5,
      // filename: "feedback.pdf",
      filename: `${scheduleDetail["candidate"]["first_name"]}-${scheduleDetail.post.job_title}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3 },
      pagebreak: { avoid: [".avoid", ".text-xs", ".text-sm"] },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    await html2pdf().from(element).set(options).save();
    if (viewchat) {
      viewchat.style.display = "block";
    }
  };

  const getProfileURL = async (url: any) => {
    await urlToBase64(url!).then(async (base64Url: any) => {
      setBase64Img(base64Url);
    });
  };

  async function urlToBase64(url: string) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.statusText}`);
      }
      const blob = await response.blob();
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
      });
    } catch (error) {
      console.error("Error converting URL to base64:", error);
      return null;
    }
  }

  const getCommunicationLevel = (level: number) => {
    switch (level) {
      case 1:
        return "Speaks with limited fluency, irregular grammar and carries a distinct accent";
      case 2:
        return "Speaks with comfortable fluency, agreeable grammar, has noticeable accent";
      case 3:
        return "Speaks with acceptable finesse/ accurate grammar and has no accent";
      case 4:
        return "Speaks with polish / finesse. Demonstrates confidence in presenting the credentials with ease";
      default:
        return "";
    }
  };

  // const openMeetingChat = () => {
  //   window.open(feedbackUrl + "/view_chat/" + schedule_id, "_blank");
  // };
  return (
    <>
      {openImageFullView && (
        <ImageView
          imgSrc={scheduleDetail["feedback"][0]["url"]}
          close={setOpenImageFullView}
        ></ImageView>
      )}

      {Object.keys(scheduleDetail).length !== 0 && (
        <div className="flex justify-center bg-gray-100 w-full min-h-screen">
          <div className="w-3/5 bg-white">
            <div className="py-2 flex justify-end items-center">
              <button
                onClick={() => downloadPDF()}
                className="flex items-center px-3 py-2 text-primary  text-sm font-semibold border  border-primary rounded-md mb-3 mx-2"
              >
                <BsFolderSymlink />
                &nbsp;&nbsp;Download pdf
              </button>
            </div>
            <div id="pdfdocument" className="pl-5 pr-5">
              <div className="flex justify-center items-center max-h-screen overflow-hidden border-b">
                <div className="pb-3">
                  <h1 className="text-sm font-semibold">
                    Interactive Technical Assessment
                  </h1>
                </div>
              </div>
              <div className="grid grid-cols-3 bg-primary border-primary p-4 gap-3 rounded-tl-lg rounded-br-lg">
                <div className="">
                  <h1 className="text-gray-200 text-xs font-light ">
                    Candidate Name
                  </h1>
                  <h1 className="text-white text-xs font-bold">
                    {scheduleDetail["candidate"]["first_name"]}{" "}
                    {scheduleDetail["candidate"]["last_name"] &&
                      scheduleDetail["candidate"]["last_name"]}
                  </h1>
                </div>
                <div className="">
                  <h1 className="text-gray-200 text-xs font-light">
                    Panelist's Name
                  </h1>
                  <h1 className="text-white text-xs font-bold">
                    {scheduleDetail?.interviewer?.candidate?.first_name}{" "}
                    {scheduleDetail?.interviewer?.candidate?.last_name &&
                      scheduleDetail?.interviewer?.candidate?.last_name}
                  </h1>
                </div>
                <div className="">
                  <h1 className="text-gray-200 text-xs font-light">
                    Recruiter's Name:
                  </h1>
                  <h1 className="text-white text-xs font-bold">
                    {scheduleDetail?.org?.first_name}{" "}
                    {scheduleDetail?.org?.last_name}
                  </h1>
                </div>
                <div className="">
                  <h1 className="text-gray-200 text-xs font-light">Role</h1>
                  <h1 className="text-white text-xs font-bold">
                    {scheduleDetail?.post?.job_title}
                  </h1>
                </div>
                <div className="">
                  <h1 className="text-gray-200 text-xs font-light">
                    Date(DD MMM YYYY):
                  </h1>
                  <h1 className="text-white text-xs font-bold">
                    {Timer.getDate(scheduleDetail?.utc_starttime)}
                  </h1>
                </div>
                <div className="">
                  <h1 className="text-gray-200 text-xs font-light">
                    Name of the Client:
                  </h1>
                  <h1 className="text-white text-xs font-bold">
                    {scheduleDetail?.post?.client_name !== ""
                      ? scheduleDetail?.post?.client_name
                      : "NA"}
                  </h1>
                </div>
              </div>
              <form>
                <div className="flex justify-between items-center my-3 grid grid-cols-2 gap-3">
                  <div className="flex justify-start items-center gap-4">
                    <h1 className="text-xs font-normal text-gray-500">
                      Candidate No Show :
                    </h1>
                    <p className="text-black text-xs font-bold">
                      {scheduleDetail?.feedback[0]?.candidate_no_show
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>
                  <div className="flex justify-start items-center gap-4">
                    <h1 className="text-xs font-normal text-gray-500">
                      Candidate Proxy :
                    </h1>
                    <p className="text-black text-xs font-bold">
                      {scheduleDetail?.feedback[0]?.proxy ? "Yes" : "No"}
                    </p>
                  </div>
                </div>
                <div className="flex justify-between items-center my-3 grid grid-cols-2 gap-3">
                  <div className="flex justify-start items-center gap-4">
                    <h1 className="text-xs font-normal text-gray-500">
                      Mode of Interview :
                    </h1>
                    <p className="text-black text-xs font-bold">
                      {scheduleDetail?.feedback[0]?.mode}
                    </p>
                  </div>
                  <div
                    className={
                      scheduleDetail?.feedback[0]?.candidate_no_show ||
                      scheduleDetail?.feedback[0]?.proxy
                        ? "disabled-div flex justify-start items-center gap-4"
                        : "flex justify-start items-center gap-4"
                    }
                  >
                    <h1 className="text-xs font-normal text-gray-500">
                      Level of Interview :
                    </h1>
                    <p className="text-black text-xs font-bold">
                      {scheduleDetail?.feedback[0]?.level}
                    </p>
                  </div>
                </div>

                <ScoringDefinition
                  tag={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? true
                      : false
                  }
                />

                <div
                  className={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? "disabled-div flex flex-col items-start gap-2 my-3 w-full"
                      : "flex flex-col items-start gap-2 my-3 w-full"
                  }
                >
                  <div className="pt-2">
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Technical Evaluation
                    </h1>
                    <h1 className="text-xs font-normal text-gray-400">
                      Please evaluate the candidate on the following on a scale
                      of 1 to 5 (1 Lowest, 5 Highest)
                    </h1>
                  </div>

                  <FeedbackSkill
                    title="Required Technical Skills"
                    skills={scheduleDetail?.feedback[0]?.fp_skill}
                  />

                  <FeedbackSkill
                    title="Preferred Technical Skills"
                    skills={scheduleDetail?.feedback[0]?.fs_skill}
                  />

                  <FeedbackSkill
                    title="Mandatory Technical Skills"
                    skills={scheduleDetail?.feedback[0]?.fm_skill}
                  />
                </div>
                <div
                  className={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? "disabled-div flex flex-col items-start gap-2 my-3 w-full"
                      : "flex flex-col items-start gap-2 my-3 w-full"
                  }
                >
                  <div className="pt-2">
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Level of Experience
                    </h1>
                    <table className="table-fixed w-full mt-2">
                      <thead className="text-sm">
                        <tr>
                          <th className="w-1/2">
                            <p className="p-2 flex justify-start text-xs">
                              Category
                            </p>
                          </th>
                          <th className="w-1/2">
                            <p className="p-2 flex justify-start text-xs">
                              Comments
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-400 ">
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">Junior</p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.junior || "-"}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">Mid</p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.mid || "-"}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">Senior</p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.senior || "-"}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">Lead</p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.lead || "-"}
                            </p>
                          </td>
                        </tr>

                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Architect
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.architect || "-"}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? "disabled-div flex flex-col items-start gap-2 my-3 w-full"
                      : "flex flex-col items-start gap-2 my-3 w-full"
                  }
                >
                  <p className="font-semibold text-xs underline text-gray-900">
                    Communication level of expertise (Defined standard, level of
                    oral articulation)
                  </p>
                  <div className="flex flex-col items-start justify-start mt-4 text-xs font-semibold text-gray-600 gap-2">
                    {getCommunicationLevel(
                      scheduleDetail?.feedback[0]?.communication_skill,
                    )}
                  </div>
                </div>
                <div
                  className={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? "disabled-div flex flex-col items-start gap-2 my-3 w-full"
                      : "flex flex-col items-start gap-2 my-3 w-full"
                  }
                >
                  <div className="pt-2">
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Observations
                    </h1>
                    <table className="table-fixed w-full mt-2">
                      <thead className="text-sm">
                        <tr>
                          <th className="w-1/2">
                            <p className="p-2 flex justify-start text-xs">
                              Communication Level
                            </p>
                          </th>
                          <th className="w-1/2">
                            <p className="p-2 flex justify-start text-xs">
                              (Ref one of the four listed above)
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-400 ">
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Technical Observation
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail.feedback[0].observation}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Analytical and problem-solving Skills
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.problem_solving_cmd}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Attitude / Aptitude demonstrated
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {
                                scheduleDetail?.feedback[0]
                                  ?.attitude_confidence_cmd
                              }
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Clarity of the answers provided
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {
                                scheduleDetail?.feedback[0]
                                  ?.inter_personal_skill_cmd
                              }
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? "disabled-div flex flex-col items-start gap-2 my-3 w-full"
                      : "flex flex-col items-start gap-2 my-3 w-full"
                  }
                >
                  <div className="pt-2">
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Final Recommendation
                    </h1>
                    <table className="table-fixed w-full mt-2">
                      <tbody className="text-gray-400 ">
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Must Hire/Hire/Hold/Do not Hire
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.recommended_status}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Junior/ Mid/ Senior/ Lead/ Architect
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.professionalism_cmd}
                            </p>
                          </td>
                        </tr>
                        <tr className="bg-gray-50 border-b-2 border-white ">
                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              Other Comments, if any:
                            </p>
                          </td>

                          <td>
                            <p className="p-2 text-xs text-gray-500">
                              {scheduleDetail?.feedback[0]?.comments}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className={
                    scheduleDetail?.feedback[0]?.candidate_no_show ||
                    scheduleDetail?.feedback[0]?.proxy
                      ? "disabled-div flex flex-col items-start gap-2 my-3 w-full"
                      : "flex flex-col items-start gap-2 my-3 w-full"
                  }
                >
                  <div className="pt-2 flex items-center  gap-4">
                    <p className="text-sm font-semibold text-gray-800 ">
                      Recommended :
                    </p>
                    <p className="text-black text-xs font-bold">
                      {scheduleDetail?.feedback[0]?.eligible_for_this_position
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>
                </div>
              </form>
              <div className="py-5">
                {base64Img ? (
                  <>
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Candidate Profile Picture
                    </h1>
                    <div className="h-32 w-32 mr-1 bg-gray-100 rounded-sm overflow-hidden">
                      <img
                        src={base64Img!}
                        alt="user_profile_photo"
                        className="h-full w-full object-cover cursor-pointer"
                        onClick={() => setOpenImageFullView(true)}
                      ></img>
                    </div>
                  </>
                ) : (
                  <>
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Candidate Profile Picture
                    </h1>
                    <div className="h-32 w-32 bg-primary rounded-full overflow-hidden ">
                      <div className="flex justify-center items-center h-32">
                        <BsPerson color="white" size={70} />
                      </div>
                    </div>
                  </>
                )}
              </div>
              {scheduleDetail &&
                scheduleDetail.code &&
                scheduleDetail.code.length > 0 && (
                  <div className="py-5">
                    <div className="pt-7 border-b border-blue-300 avoid">
                      <h1 className="text-sm font-semibold text-gray-800 mb-2">
                        Programming Code
                      </h1>
                    </div>

                    {scheduleDetail &&
                      scheduleDetail.code &&
                      scheduleDetail.code.map((x: any, index: number) => (
                        <div className="avoid" key={index}>
                          <h1 className="text-sm font-semibold text-gray-900 pt-2">
                            {x.title}
                          </h1>
                          <pre className="text-sm font-normal text-gray-400 pb-2">
                            {x.code}
                          </pre>
                        </div>
                      ))}
                  </div>
                )}
              {scheduleDetail.video_url && (
                <div className="py-5">
                  <div className="pt-7 border-b border-blue-300 avoid flex items-center gap-2 justify-between">
                    <h1 className="text-sm font-semibold text-gray-800 mb-2">
                      Interview Video
                    </h1>
                    <CopyLinkButton videoUrl={scheduleDetail.video_url} />
                  </div>
                  <h1 className="text-md font-bold text-black py-10">
                    {S.getFileExtension(scheduleDetail.video_url) !== "mp4" ? (
                      <ReactHlsPlayer
                        src={scheduleDetail.video_url}
                        autoPlay={false}
                        controls={true}
                        width="750"
                        height="500"
                      />
                    ) : (
                      <video
                        src={scheduleDetail.video_url}
                        autoPlay={false}
                        controls={true}
                        width="750"
                        height="500"
                      />
                    )}
                  </h1>
                </div>
              )}
              {/* <div className="py-5">
                <h1
                  onClick={() => {
                    openMeetingChat();
                  }}
                  className="text-sm font-semibold text-primary underline mb-2 cursor-pointer"
                  id="viewchat"
                >
                  View Chat
                </h1>
              </div> */}
              <div className="my-5"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewTechFeedbackNamIT;

export const CopyLinkButton = ({ videoUrl }: { videoUrl: string }) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleClick = () => {
    setShowTooltip(true);
    const encryptedUrl = encodeURIComponent(encryptUrl(videoUrl));
    const newTabUrl = `${feedbackUrl}/video_player/${encryptedUrl}`;

    setShowTooltip(true);

    const textarea = document.createElement("textarea");
    textarea.value = newTabUrl;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Failed to copy text");
    } finally {
      document.body.removeChild(textarea);
    }
    setTimeout(() => {
      setShowTooltip(false);
    }, 1500);
  };

  return (
    <div className="relative">
      {showTooltip && (
        <span className="absolute -top-7 left-1/2 z-50 -translate-x-1/2 transform whitespace-nowrap rounded-xl bg-black px-2 py-1 text-xs text-white">
          ✅ Copied!
        </span>
      )}
      <button
        onClick={handleClick}
        className="text-primary flex items-center gap-1 cursor-pointer hover:text-indigo-700 hover:underline transition-all ease-in-out"
      >
        Copy Video Link
      </button>
    </div>
  );
};
